import { render, staticRenderFns } from "./DoubleSideTriangleHorizontal.vue?vue&type=template&id=1de5df22&scoped=true&"
import script from "./DoubleSideTriangleHorizontal.vue?vue&type=script&lang=js&"
export * from "./DoubleSideTriangleHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5df22",
  null
  
)

export default component.exports